import { filter, Observable, pipe, UnaryFunction } from 'rxjs';

export function filterIsNotEmpty<TValue>(
  value: TValue | null | undefined | false,
): value is TValue {
  return value !== null && value !== undefined && value !== false;
}

export function rxFilterIsNotEmpty<T>(): UnaryFunction<
  Observable<T | null | undefined>,
  Observable<T>
> {
  return pipe(filter(filterIsNotEmpty));
}

export function filterArrayIsNotEmpty<TValue>(
  value: TValue[] | null | undefined | false,
): value is TValue[] {
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  return value !== null && value !== undefined;
}

export function rxFilterArrayIsNotEmpty<T>(): UnaryFunction<
  Observable<T[] | null | undefined>,
  Observable<T[]>
> {
  return pipe(filter(filterArrayIsNotEmpty));
}
